import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import TagChip, {tagChipSizes as SIZES} from '@adv-mt/mt-tag-chip'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

export const CardAdContent = ({monthlySubscriptionFee, subscriptionVehicleState, title}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {VEHICLE_STATE_IDS, VEHICLE_STATE_LITERALS} = config.get('subscription')

  const hasNewTag = subscriptionVehicleState === VEHICLE_STATE_IDS.NEW

  const hasMonthlyFee = Boolean(monthlySubscriptionFee)
  const monthlyFee = typeof monthlySubscriptionFee === 'number' ? i18n.c(monthlySubscriptionFee) : 0

  return (
    <div className={`mt-ListCarouselCardAdContent`}>
      {hasMonthlyFee ? (
        <>
          <span className={`mt-ListCarouselCardContent-preTitle`}>{i18n.t('COMMON.FEE_FROM')}</span>
          <TitleBasic
            as={titleBasicTags.h3}
            color={titleBasicColors.currentColor}
            size={titleBasicSizes.xs}
            title={i18n.t('COMMON.MONTHLY_FEE', {
              amount: monthlyFee
            })}
          />
        </>
      ) : null}
      <div className={`mt-ListCarouselCardContent-description`}>{title}</div>
      <div className={`mt-ListCarouselCardContent-tags`}>
        <TagChip label={i18n.t('COMMON.RENTING')} size={SIZES.SMALL} />
        {hasNewTag ? (
          <TagChip label={i18n.t(VEHICLE_STATE_LITERALS[VEHICLE_STATE_IDS.NEW])} size={SIZES.SMALL} />
        ) : null}
      </div>
    </div>
  )
}

CardAdContent.displayName = 'CardAdContent'
CardAdContent.propTypes = {
  monthlySubscriptionFee: PropTypes.number,
  subscriptionVehicleState: PropTypes.string,
  title: PropTypes.string
}
